export default __webpack_public_path__ + "static/media/Pcv1SelectH2.99a9c123.png";